import React from "react";
import type { CRMChannel } from "@jugl-web/rest-api";
import { ContactIntelligenceFieldValue } from "./components/ContactIntelligenceFieldValue";
import { ContactIntelligenceRowData } from "../../types";

export const ContactIntelligenceFieldRow: React.FC<
  Omit<ContactIntelligenceRowData, "id"> & {
    onConversationNavigate?: (params: {
      channel: CRMChannel;
      convId: string;
    }) => void;
  }
> = ({ Icon, label, value, onConversationNavigate }) => (
  <div className="flex items-center gap-2">
    <div className="flex w-[135px] shrink-0 items-center gap-1.5">
      <span className="text-dark-600 flex h-3.5 w-3.5 shrink-0 items-center justify-center [&_svg]:h-full [&_svg]:w-full">
        <Icon />
      </span>
      <span className="text-dark-700 font-secondary text-[11px] leading-[140%] tracking-[0.10px]">
        {label}:
      </span>
    </div>
    <ContactIntelligenceFieldValue
      value={value}
      onConversationNavigate={onConversationNavigate}
    />
  </div>
);
